import $ from 'jquery';
import 'slick-carousel';
import Swiper from 'swiper'
import { register } from 'swiper/element/bundle'
import 'swiper/css'
import 'swiper/css/navigation'
import 'swiper/css/pagination'
import 'swiper/css/grid'

$(function(){
	register()
	const swiperEvents = new Swiper(".swiper-container", {
		slidesPerView: 1, 
		grid: {
			rows: 3,
			fill: 'column'
		},
		slidesToShow: 3,
		navigation: {
			nextEl: '.swiper-button-next',
			prevEl: '.swiper-button-prev'
		},
		pagination: {
			clickable: true,
			el: '.swiper-pagination',
			type: 'bullets',
		},
		breakpoints: {
			1600: {				
				slidesPerView: "auto",	
				slidesPerGroup: 4,
				grid: {
					rows: 1,
					fill: 'row'
				}
			},
			1200: {
				slidesPerView: "auto",	
				slidesPerGroup: 3,
				grid: {
					rows: 1,
					fill: 'row'
				}
			},
			991: {
				slidesPerView: "auto",	
				slidesPerGroup: 1,
				grid: {
					rows: 1,
					fill: 'row'
				}
			},
			768: {
				slidesPerView: "auto",	
				slidesPerGroup: 2,
				grid: {
					rows: 1,
					fill: 'row'
				}
			}
		},
	})

	swiperEvents.on('fromEdge', function(){
		$('.swiper-container').removeClass('reached-end');	
	});

	swiperEvents.on('slideChangeTransitionEnd', function () {
		if (swiperEvents.isEnd) {
				$('.swiper-container').addClass('reached-end');
			}
	});

	swiperEvents.on('reachEnd', function () {
		$('.swiper-container').addClass('reached-end');
	})
 
	$('.hero__carousel').slick({
		infinite: true,
		arrows: false,
		dots: true, 

	});
	
	const swiperStudentStories = new Swiper(".highlight-swiper-container", {
		slidesPerGroup: 1,
		slidesPerView: 1,
		navigation: {
			nextEl: '.swiper-button-next',
			prevEl: '.swiper-button-prev',
			clickable: true,
		},
		breakpoints: {
			991: {
				slidesPerView: 1.25,
				slidesPerGroup: 1,
			}
		},
	})

	
	// $('.laurea-carousel--medium').on('lazyLoaded', function (e, slick, image, imageSource) {
	// 	$(image).parent().css('background-image', 'url(' + imageSource + ')');
	// 	$(image).remove();
	// });
});



